import { render, staticRenderFns } from "./DuanJuList.vue?vue&type=template&id=26a1d054&scoped=true&"
import script from "./DuanJuList.vue?vue&type=script&lang=js&"
export * from "./DuanJuList.vue?vue&type=script&lang=js&"
import style0 from "./DuanJuList.vue?vue&type=style&index=0&id=26a1d054&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a1d054",
  null
  
)

export default component.exports